export default function formatAmount(amount: string) {
    return new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR',}).format(parseFloat(amount));
}
